import { render, staticRenderFns } from "./ModalReceptionRequestMaterials.vue?vue&type=template&id=d3072916"
import script from "./ModalReceptionRequestMaterials.vue?vue&type=script&lang=js"
export * from "./ModalReceptionRequestMaterials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports